export default __webpack_public_path__ + "static/media/experiment-card-template.0e4a3567.pptx";